// extracted by mini-css-extract-plugin
export default {"imageWrapper":"BF-z","hovered":"CF-z","hoverImage":"DF-z","mainImage":"EF-z","imageNoBackground":"FF-z","fullSizeImage":"GF-z"};